// extracted by mini-css-extract-plugin
module.exports = {"chartArea":"BeautyPointsDetailsTile_chartArea__nJaOm","chartSelection":"BeautyPointsDetailsTile_chartSelection__BrZ_A"};